export const isNumberArray = (array: unknown): array is number[] => {
  if (!Array.isArray(array)) {
    return false;
  }

  return array.every((item) => typeof item === 'number');
};
